import { render, staticRenderFns } from "./QuotesView.vue?vue&type=template&id=53685230&"
import script from "./QuotesView.vue?vue&type=script&lang=js&"
export * from "./QuotesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports